import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'has_the_fac_failed_to_implement_any_applicable_court_orders_arb'

export const dataPointDefinition = {
  retracedId: 'has_the_fac_failed_to_implement_any_applicable_court_orders_arb',
  name: 'Has the facility failed to implement any applicable court orders, arbitration awards, conciliation agreements and/or settlements?',
  description:
    'Answer Not Applicable if the facility is not subject to any court orders, arbitration awards, conciliation agreements and settlements. \r\r\n\r\r\nCourt Orders: Consider only legally binding court orders that are not subject to appeal. Court orders may be issued by courts of general jurisdiction or by specialized labor courts.\r\r\nArbitration awards: Arbitration awards may be issued by an individual arbitrator, a board of arbitrators or an arbitration court (not acting as a court of law), who decide on the outcome of a dispute.\r\r\nConciliated/mediated agreements: During conciliation/mediation, a third party assists the parties to a dispute to negotiate an agreement.\r\r\nSettlements: Consider only legally binding settlements.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'ynna',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'ynna',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 3,
      slcpOptionName: 'ynna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wt-wor-2',
      version: '1.5.0',
      provider: 'slcp',
    },
  ],
  sortingId: 11630,
  sectionId: '2.2.5.5',
  impactArea: 'Harassment and Abuse',
  impactAreaId: 'HARRASSMENT_AND_ABUSE',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
